
import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import LeadFormButton from "@/components/common/LeadFormButton.vue";
import LeadFormsWrapper from "@/components/common/LeadFormsWrapper.vue";
import VueI18n from "vue-i18n";
import { IUser } from "@/models/User";
import { AVALON_HOUSFY_ACCOUNT_ID } from "@/constants";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("auth", {
      user: "getUser",
    }),
  },
  components: { LeadFormButton, LeadFormsWrapper },
})
export default class OperationsHeader extends Vue {
  @Inject() readonly curr_business!: string;

  protected user!: IUser;

  @Prop({ type: Number, required: true })
  protected totalRequests!: number;

  @Prop({ type: Boolean, default: false })
  protected canCreateLeads?: boolean;

  protected clientModal = false;

  protected get mainTitle(): string | VueI18n.LocaleMessages {
    switch (this.curr_business) {
      case "mortgages":
        return this.$tc("mortgages", 2);
      case "supplies":
        return this.$tc("supply", 2);
      default:
        return this.$t("applications");
    }
  }

  protected get creationLeadButtonLabelKey(): string {
    switch (this.curr_business) {
      case "mortgages":
        return "newMortgage";
      case "supplies":
        return "newSupply";
      default:
        return "newLead";
    }
  }

  protected get hasAvalonParent(): boolean {
    return this.user?.parentId === AVALON_HOUSFY_ACCOUNT_ID;
  }
}
